module.exports = __webpack_public_path__ + "static/media/bg-mobi-navi.2d5af22a.png";